import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Radio,
  DialogTitle,
  FormControlLabel,
  IconButton,
  makeStyles,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import _, { includes } from "lodash";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import { Autocomplete } from "@material-ui/lab";
import AddIcon from "@material-ui/icons/Add";
import CloudDownload from "@material-ui/icons/CloudDownload";
import * as XLSX from "xlsx";
import axios from "axios";
import {
  CreateBillAPI,
  GetAllAccountsWithLightweightAPI,
  GetAllBanksAPI,
  GetAllBillsAPI,
  GetAllChallansAPI,
  UpdateChallanAPI,
  GetAccountAPI,
  GetEntityAPI,
  UpdateChallanBilledStatusAPI,
  UpdateBillAPI,
  DeleteBillAPI,
  baseUrl,
  GenerateBillPDFAPI,
} from "../../config/api";
import { Receipt } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import BillView from "./BillView";
import Moment from "moment";

import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateUtils from "@date-io/moment";
import { invTemp as invoiceTemplate } from "../../assets/html/invTemp";
import { dataURItoBlob, htmlTemplateToDataString } from "../../utils";
import {
  mergeChallansForBill,
  computeInvoiceTotals,
  applyExternalDiscountOnTaxable,
  buildBillPreviewFromChallans,
} from "../../utils/billInvoiceTotals";
import { extendMoment } from "moment-range";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { invTemp } from "../../assets/html/invTemp.js";
import { invTempOld } from "../../assets/html/invTempOld.js";
import { shouldUseNewPrintLogic } from "../../config/printConfig.js";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';


const moment = extendMoment(Moment);

/** Empty = no discount (0). Non-empty must be 1–100 on submit. */
function parseExternalDiscountForSubmit(input) {
  const s = input == null ? "" : String(input).trim();
  if (s === "") return { ok: true, value: 0 };
  const n = Number(s);
  if (!Number.isFinite(n) || n < 1 || n > 100) return { ok: false };
  return { ok: true, value: n };
}

/** Live preview: invalid or empty → 0% discount. */
function parseExternalDiscountForPreview(input) {
  const parsed = parseExternalDiscountForSubmit(input);
  return parsed.ok ? parsed.value : 0;
}

/** Parse invCreationDate: DD-MM-YYYY string, or ISO / { $date } if API returns that shape. */
function parseBillDateForDisplay(value) {
  if (value == null || value === "") return "";
  const raw =
    typeof value === "object" && value != null && value.$date != null
      ? value.$date
      : value;
  const parsed = moment(raw, ["DD-MM-YYYY", moment.ISO_8601], true);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : "";
}

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(-24),
    right: theme.spacing(2),
  },
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));

/** Bill number: prefer API billNumber, else parse from code using segment fallback rules. */
function getBillNumber(record) {
  const apiBillNumber = record?.billNumber;
  if (apiBillNumber != null && String(apiBillNumber).trim() !== "") {
    return String(apiBillNumber).trim();
  }

  const code = record?.code;
  if (code == null || code === "") return "";

  const s = String(code);
  if (s.length <= 9) return "";

  const trimmed = s.slice(0, -9);
  const parts = trimmed.split("-");
  // Check the token after the 3rd hyphen:
  // - numeric => use it
  // - text => skip to next token
  if (parts.length <= 3) return "";
  const afterThirdHyphen = (parts[3] ?? "").trim();
  const afterFourthHyphen = (parts[4] ?? "").trim();
  if (afterThirdHyphen === "") return afterFourthHyphen;

  const isNumericAfterThird = /^\d+$/.test(afterThirdHyphen);
  return isNumericAfterThird ? afterThirdHyphen : afterFourthHyphen;
}

function getTotalBillQty(items) {
  if (!Array.isArray(items) || items.length === 0) return 0;
  return items.reduce((sum, it) => {
    const n = Number(it?.qty ?? it?.quantity ?? it?.Quantity ?? 0);
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);
}

const columns = [
  { id: "billNumber", label: "Bill number", minWidth: 100 },
  { id: "code", label: "Code", minWidth: 100 },
  { id: "party", label: "Party", minWidth: 100 },
  { id: "qty", label: "Qty", minWidth: 60, align: "right" },
  { id: "isPaid", label: "Is paid", minWidth: 90 },
  // { id: "paymentStatus", label: "Payment Status", minWidth: 100 },
  {
    id: "createdAt",
    label: "Created At",
    format: (value) => (value ? moment(value).format("DD-MM-YYYY") : ""),
  },
  {
    id: "invCreationDate",
    label: "Invoice Date",
    format: (value) => parseBillDateForDisplay(value),
  },
  { id: "action", label: "Action" },
];

const groupedChallansColumns = [
  {
    id: "party",
    label: "Party",
  },
  { id: "code", label: "Code" },
  {
    id: "amount",
    label: "Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },

  {
    id: "createdAt",
    label: "Created At",
    format: (value) => (value ? moment(value).format("DD-MM-YYYY") : ""),
  },
];

const billTemplates = [
  { label: "Standard", value: "invTemp" },
  // 
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BillPrintDialog = ({
  open,
  onClose,
  billTemplates,
  selectedBillTemplate,
  setSelectedBillTemplate,
  includeQRCode,
  onToggleQRCode,
  banks,
  selectedBankId,
  handlePrintForCustomer,
}) => (
  <Dialog
    onClose={onClose}
    aria-labelledby="bill-print-dialog"
    open={open}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle id="bill-print-dialog">Print Bill</DialogTitle>
    <DialogContent>
      <List>
        <Box style={{ marginBottom: "16px" }}>
          <DialogTitle style={{ padding: "8px 0", fontSize: "16px", fontWeight: "bold" }}>
            Select Template
          </DialogTitle>
          {billTemplates.map(({ label, value }) => (
            <ListItem
              button
              key={value}
              onClick={() => setSelectedBillTemplate(value)}
              style={{
                border: value === selectedBillTemplate ? "2px solid #1976d2" : "1px solid #e0e0e0",
                marginBottom: "8px",
                borderRadius: "4px",
              }}
            >
              <Radio checked={value === selectedBillTemplate} />
              <ListItemText primary={label} />
            </ListItem>
          ))}
        </Box>

        <ListItem
          onClick={(e) => {
            // Prevent dialog/backdrop click handling when toggling QR checkbox
            e.stopPropagation();
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={includeQRCode}
                onChange={(e) => onToggleQRCode(e.target.checked, e)}
                color="primary"
              />
            }
            label="Include QR Code on PDF"
          />
        </ListItem>

        {/* {includeQRCode && (
          <Box style={{ marginTop: "16px" }}>
            <DialogTitle style={{ padding: "8px 0", fontSize: "16px", fontWeight: "bold" }}>
              Select Bank (QR Code)
            </DialogTitle>
            {banks.length === 0 ? (
              <ListItem>
                <ListItemText
                  primary="No banks available"
                  secondary="Please add banks in settings"
                  style={{ color: "#999" }}
                />
              </ListItem>
            ) : (
              banks.map((bank) => (
                <ListItem
                  button
                  key={bank._id}
                  selected={bank._id === selectedBankId}
                  onClick={() => setSelectedBankId(bank._id)}
                  style={{
                    border: bank._id === selectedBankId ? "2px solid #1976d2" : "1px solid #e0e0e0",
                    marginBottom: "8px",
                    borderRadius: "4px"
                  }}
                >
                  <Radio checked={bank._id === selectedBankId} />
                  <ListItemAvatar>
                    <Avatar
                      variant="square"
                      src={bank.qrCode ? baseUrl + bank.qrCode : ""}
                      alt={`${bank.bankName} QR`}
                      style={{ width: 56, height: 56, marginRight: 8 }}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={bank.bankName}
                    secondary={`IFSC: ${bank.ifscCode || 'N/A'}`}
                  />
                </ListItem>
              ))
            )}
          </Box>
        )} */}
      </List>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="secondary">
        Cancel
      </Button>
      <Button onClick={handlePrintForCustomer} color="primary" variant="outlined">
        Print for customer
      </Button>
      {/* <Button onClick={handleBillPrint} color="primary" variant="contained">
        Download PDF
      </Button> */}
    </DialogActions>
  </Dialog>
);

const MAX_ROWS_PER_PAGE = 100; // Maximum pagination limit for performance

export const BillList = React.memo((props) => {
  const { searchTerm, filter } = props;
  const classes = useStyles();
  const authToken = useSelector((state) => state.userReducer.authToken);

  const [bills, setBills] = useState([]);
  const [openBillAddDialog, setOpenBillAddDialog] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [billTotal, setBillTotal] = useState(0);
  const [openViewDialog, setOpenViewDialog] = useState(null);
  const [openBulkBillDialog, setOpenBulkBillDialog] = useState(false);
  const [openAccountViewDialog, setOpenAccountViewDialog] = useState(null);
  const [challans, setChallans] = useState([]);
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  const [includeQRCode, setIncludeQRCode] = useState(false);
  const [banks, setBanks] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [selectedBillTemplate, setSelectedBillTemplate] = useState(
    billTemplates[0].value
  );
  const [showInvoiceSelectionDialog, setShowInvoiceSelectionDialog] = useState(false);
  const [sendWa, setSendWa] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openBillEditDialog, setOpenBillEditDialog] = useState(false);
  const [billToEdit, setBillToEdit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const [entity, setEntity] = useState("");

  // Track previous state to only refresh when dialog closes (not opens)
  const prevOpenBulkBillDialog = useRef(false);

  useEffect(() => {
    const abortController = new AbortController();

    const fetchData = async () => {
      await _getEntity(abortController.signal);
      await _getBanks(abortController.signal);
    };

    fetchData();

    // Cleanup: cancel requests on unmount
    return () => {
      abortController.abort();
    };
  }, []);

  const selectedBank = banks.find((b) => b._id === selectedBankId);

  async function _getBanks(signal) {
    try {
      const res = await axios.get(GetAllBanksAPI(userInfo.entity), {
        signal: signal, // Add abort signal for request cancellation
      });
      const fetched = res.data.banks || [];
      setBanks(fetched);
      if (fetched.length > 0 && !selectedBankId) {
        setSelectedBankId(fetched[0]._id);
      }
    } catch (err) {
      if (err.name === 'AbortError' || err.code === 'ECONNABORTED') {
        // Request was cancelled, ignore error
        return;
      }
      console.error("Failed to fetch banks", err);
    }
  }

  async function _getEntity(signal) {
    try {
      let res = await axios.get(GetEntityAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        signal: signal, // Add abort signal for request cancellation
      });
      setEntity(res.data);
    } catch (err) {
      if (err.name === 'AbortError' || err.code === 'ECONNABORTED') {
        // Request was cancelled, ignore error
        return;
      }
      setEntity("");
      // toast.error(('Cannot fetch data'), {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
    }
  }

  async function _getChallans() {
    try {
      let res = await axios.get(GetAllChallansAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setChallans(res.data.challans);
    } catch (err) {
      // console.log(err);
      // toast.error(('Cannot fetch data'), {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
    }
  }

  const _getBills = useCallback(
    async (pageIndex, limit, search, signal) => {
      setLoading(true);
      const safeLimit =
        limit === undefined || limit === null || Number.isNaN(limit)
          ? 10
          : Math.min(Number(limit), MAX_ROWS_PER_PAGE);
      const safePage =
        pageIndex === undefined || pageIndex === null || Number.isNaN(pageIndex)
          ? 0
          : Number(pageIndex);

      try {
        let query = `&limit=${safeLimit}&skip=${safePage * safeLimit}`;
        const trimmedSearch = search == null ? "" : String(search).trim();
        if (trimmedSearch !== "") {
          query += `&search=${encodeURIComponent(trimmedSearch)}`;
        }

        const res = await axios.get(GetAllBillsAPI(userInfo.entity) + query, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
          signal,
        });
        setBills(res.data.bills || []);
        setBillTotal(res.data.total ?? 0);
      } catch (err) {
        if (err.name === "AbortError" || err.code === "ECONNABORTED") {
          return;
        }
        console.error("Error fetching bills:", err);
      } finally {
        setLoading(false);
      }
    },
    [authToken, userInfo.entity]
  );

  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  useEffect(() => {
    const abortController = new AbortController();
    _getBills(page, rowsPerPage, searchTerm, abortController.signal);
    return () => {
      abortController.abort();
    };
  }, [page, rowsPerPage, searchTerm, _getBills]);

  useEffect(() => {
    if (prevOpenBulkBillDialog.current && !openBulkBillDialog) {
      const abortController = new AbortController();
      _getBills(page, rowsPerPage, searchTerm, abortController.signal);
      return () => {
        abortController.abort();
      };
    }
    prevOpenBulkBillDialog.current = openBulkBillDialog;
  }, [openBulkBillDialog, page, rowsPerPage, searchTerm, _getBills]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = Math.min(+event.target.value, MAX_ROWS_PER_PAGE);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  function closeViewDialog() {
    setOpenViewDialog(null);
  }

  const handleConfirmDelete = async () => {
    if (!selectedItem || !selectedItem._id) {
      toast.error("Invalid item selected.");
      return;
    }

    console.log(selectedItem, "itemwa");

    try {
      const res = await axios.delete(DeleteBillAPI(selectedItem._id), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        data: {
          challanIds: selectedItem.challanIds, // pass challan IDs from the selected item
        },
      });

      if (res.status === 200) {
        toast.success("Deleted successfully!");
        _getBills(page, rowsPerPage, searchTerm); // Refresh the list
      } else {
        toast.error("Unexpected response from server.");
      }
    } catch (err) {
      const message =
        err.response?.data?.message ||
        err.message ||
        "Delete failed due to server error.";
      toast.error(message);
      console.error("Deletion error:", err);
    } finally {
      setDeleteDialogOpen(false);
      setSelectedItem(null);
    }
  };

  const handleOpenEditDialog = (bill) => {
    setBillToEdit(bill);
    setOpenBillEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenBillEditDialog(false);
    setBillToEdit(null);
  };


  async function _onPreview(selectedItem, wa, includeQr, bank, templateType = selectedBillTemplate) {
    const log = (msg, ...args) => console.log("[Download PDF]", msg, ...args);
    try {
      if (_.isEmpty(selectedItem)) {
        log("Aborted: no selected item");
        return;
      }
      log("Started — selectedItem.code:", selectedItem?.code, "| sendWa:", wa, "| template:", templateType);

      let htmlData = {},
        htmlTemplate = {};
      const { party } = selectedItem;
      log("Fetching account for party:", party?.accountName, "| accountId:", party?.accountId);
      let accountRes = await axios.get(GetAccountAPI(party.accountId), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      log("Account loaded");

      let partyGstNumber = accountRes.data.gstNumber;
      let partyAddress = accountRes.data.address + "," + accountRes.data.city + "," + accountRes.data.state + "," + accountRes.data.country;

      htmlData = {
        invDate: selectedItem.invCreationDate,
        includeQRCode: includeQr,
        clientAddress: partyAddress,
        isEligibleForIgst: accountRes.data?.isEligibleForIgst,
        clientName: party.accountName,
        clientGSTNo: partyGstNumber,
        challanDate: moment().format("DD-MM-YYYY"),
        items: selectedItem.items,
        // Always use the selected bank for bank details; QR checkbox only controls QR visibility
        bank: bank || null,
        bankQrUrl:
          includeQr && bank?.qrCode ? `${baseUrl}${bank.qrCode}` : null,
        billCode: getBillNumber(selectedItem),
        entityDetails: entity,
        packagingCosts: selectedItem.packagingCosts,
        packagingTaxPercents: selectedItem.packagingTaxPercents,
        externalDiscountPercentage:
          selectedItem.externalDiscountPercentage ?? 0,
      };

      console.log(htmlData, "htmlData while generating")

      let options = {
        orientation: "p",
        unit: "pt",
        format: [850, 1066],
        putOnlyUsedFonts: true,
        margin: [15, 15, 15, 15],
        // Fallback (browser-generated PDF) does not support CSS paged counters,
        // so we render page numbers via jsPDF.
        addPageNumbers: true,
        pageNumberStart: 1,
        // Row-aware paging: slice PDF at row boundaries so no bill row is cut across pages.
        rowAwarePaging: true,
        itemsTableId: "invoice-items-table",
        // Higher render width + scale 4 + PNG in utils = sharp print.
        renderWidthPx: 1400,
      };

      let templateRenderer =
         invTemp;
      if (templateType !== "invoiceTemplate" && !shouldUseNewPrintLogic(selectedItem?.createdAt)) {
        templateRenderer = invTempOld;
      }
      htmlTemplate = templateRenderer(htmlData);
      log("HTML template ready, length:", htmlTemplate?.length);

      const handlePdfBlob = (pdfBlob, source = "unknown") => {
        log("handlePdfBlob called — source:", source, "| blob size:", pdfBlob?.size, "| type:", pdfBlob?.type, "| wa:", wa);
        if (wa) {
          const phoneNumber = party.whatsappNumber || accountRes.data.mobile;
          if (!phoneNumber) {
            toast.error("No WhatsApp number found for this party");
            return;
          }
          const formData = new FormData();
          formData.append("file", pdfBlob, `Bill_${selectedItem.code}.pdf`);
          formData.append("phone", phoneNumber);
          formData.append("message", `Bill #${selectedItem.code} dated ${moment().format("DD-MM-YYYY")}`);
          axios
            .post(`${baseUrl}/send-whatsapp/ledgers`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
              },
            })
            .then((response) => {
              if (response.data.success) toast.success("Bill sent successfully on WhatsApp!");
              else throw new Error(response.data.message || "Failed to send bill on WhatsApp");
            })
            .catch((error) => {
              console.error("WhatsApp send error:", error);
              toast.error(error.message || "Failed to send bill on WhatsApp");
            });
        } else {
          const blob =
            pdfBlob.type === "application/pdf"
              ? pdfBlob
              : new Blob([pdfBlob], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          const printWin = window.open(url, "_blank");
          if (printWin) {
            let printed = false;
            const doPrint = () => {
              if (printed) return;
              printed = true;
              try {
                printWin.print();
              } catch (_) { }
            };
            printWin.onload = doPrint;
            setTimeout(doPrint, 1200);
            // toast.info("For print to match the server PDF, use 100% scale and enable 'Background graphics' in the print dialog.", { autoClose: 6000 });
          } else {
            window.open(url);
            toast.warning("Allow pop-ups to auto-open print. You can print from the new tab (Ctrl/Cmd+P).");
          }
        }
      };

      try {
        log("Calling server POST", GenerateBillPDFAPI());
        const res = await axios.post(GenerateBillPDFAPI(), { html: htmlTemplate }, {
          headers: { Authorization: `Bearer ${authToken}` },
          responseType: "blob",
          timeout: 60000,
        });
        const ok = res.status === 200;
        const contentType = String(res?.headers?.["content-type"] || "");
        const isPdfType = contentType.toLowerCase().includes("application/pdf");
        const blob = res.data instanceof Blob && res.data.size > 0 ? res.data : null;
        log("Server response — status:", res.status, "| contentType:", contentType, "| blob size:", blob?.size ?? "n/a");

        const isActualPdf =
          ok &&
          blob &&
          isPdfType &&
          (await (async () => {
            try {
              const buf = await blob.slice(0, 4).arrayBuffer();
              const bytes = new Uint8Array(buf);
              return bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46; // %PDF
            } catch (_) {
              return false;
            }
          })());
        log("isActualPdf (magic bytes %PDF):", isActualPdf);

        let pdfToUse = isActualPdf ? blob : null;
        let bodyText = null;
        if (!pdfToUse && ok && blob && isPdfType) {
          try {
            bodyText = await blob.text();
            if (bodyText && bodyText.trim().startsWith("{")) {
              const parsed = JSON.parse(bodyText);
              if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
                const keys = Object.keys(parsed).filter((k) => /^\d+$/.test(k)).map(Number).sort((a, b) => a - b);
                if (keys.length > 1000) {
                  const arr = new Uint8Array(keys.length);
                  keys.forEach((i) => { arr[i] = parsed[i] & 0xff; });
                  const first = arr[0] === 0x25 && arr[1] === 0x50 && arr[2] === 0x44 && arr[3] === 0x46;
                  if (first) {
                    log("Server sent PDF as JSON; rebuilt binary PDF, length:", arr.length);
                    pdfToUse = new Blob([arr], { type: "application/pdf" });
                  }
                }
              }
            }
          } catch (e) {
            log("Could not rebuild PDF from JSON:", e?.message);
          }
        }

        if (pdfToUse) {
          log("Using SERVER PDF — opening in new tab");
          toast.success("Opening server-generated PDF.");
          handlePdfBlob(pdfToUse, "server");
          return;
        }
        if (bodyText != null) {
          log("Server did not return PDF (body preview):", bodyText?.slice?.(0, 300));
        }
      } catch (serverErr) {
        log("Server request failed:", serverErr?.message ?? serverErr, serverErr?.response?.status);
      }

      log("Falling back to BROWSER-generated PDF");
      toast.warning("Server PDF unavailable — opening browser-generated preview. Layout will differ from the server PDF.");
      await htmlTemplateToDataString(htmlTemplate, options, async (dataString) => {
        const pdfBlob = dataURItoBlob(dataString);
        handlePdfBlob(pdfBlob, "browser-fallback");
      });
    } catch (error) {
      console.error("Preview generation error:", error);
      toast.error("Error generating bill preview");
    }
  }

  /** Opens bill as HTML in a new window and triggers browser print for better quality when printing for customers. */
  async function _onPrintForCustomer(selectedItem, includeQr, bank, templateType = selectedBillTemplate) {
    try {
      if (_.isEmpty(selectedItem)) return;
      const { party } = selectedItem;
      const accountRes = await axios.get(GetAccountAPI(party.accountId), {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      const partyGstNumber = accountRes.data.gstNumber;
      const partyAddress = [
        accountRes.data.address,
        accountRes.data.city,
        accountRes.data.state,
        accountRes.data.country,
      ].filter(Boolean).join(", ");

      const htmlData = {
        invDate: selectedItem.invCreationDate,
        includeQRCode: includeQr,
        clientAddress: partyAddress,
        isEligibleForIgst: accountRes.data?.isEligibleForIgst,
        clientName: party.accountName,
        clientGSTNo: partyGstNumber,
        challanDate: moment().format("DD-MM-YYYY"),
        items: selectedItem.items,
        // Always use the selected bank for bank details; QR checkbox only controls QR visibility
        bank: bank || null,
        bankQrUrl: includeQr && bank?.qrCode ? `${baseUrl}${bank.qrCode}` : null,
        billCode: getBillNumber(selectedItem),
        entityDetails: entity,
        packagingCosts: selectedItem.packagingCosts,
        packagingTaxPercents: selectedItem.packagingTaxPercents,
        externalDiscountPercentage:
          selectedItem.externalDiscountPercentage ?? 0,
      };

      let templateRenderer =  invTemp;
      if (templateType !== "invoiceTemplate" && !shouldUseNewPrintLogic(selectedItem?.createdAt)) {
        templateRenderer = invTempOld;
      }
      const htmlTemplate = templateRenderer(htmlData);

      const printWin = window.open("", "_blank", "width=900,height=700,scrollbars=yes,resizable=yes");
      if (!printWin) {
        toast.error("Please allow pop-ups to print the bill.");
        return;
      }
      printWin.document.write(htmlTemplate);
      printWin.document.close();

      const doc = printWin.document;
      const waitForImages = () => {
        const imgs = doc.getElementsByTagName("img");
        const promises = Array.from(imgs).map(
          (img) =>
            new Promise((resolve) => {
              if (img.complete) resolve();
              else {
                img.onload = resolve;
                img.onerror = resolve;
              }
            })
        );
        return Promise.race([Promise.all(promises), new Promise((r) => setTimeout(r, 2500))]);
      };

      if (printWin.document.readyState === "complete") {
        await waitForImages();
      } else {
        await new Promise((resolve) => {
          printWin.onload = () => { waitForImages().then(resolve); };
        });
      }
      printWin.focus();
      printWin.print();
    } catch (error) {
      console.error("Print for customer error:", error);
      toast.error("Error opening bill for print");
    }
  }

  const handlePrintDialog = (item, isWa = false) => {
    setSelectedItem(item);
    setSendWa(isWa);
    setSelectedBillTemplate(billTemplates[0].value);
    setShowInvoiceSelectionDialog(true);
  };

  const handleQRCodeToggle = (checked, event) => {
    if (event) {
      event.stopPropagation();
    }
    setIncludeQRCode(checked);
    if (checked && banks.length > 0 && !selectedBankId) {
      setSelectedBankId(banks[0]._id);
    }
  };

  const handleBillPrint = () => {
    if (!selectedItem) return;

    const billBank = selectedItem.bankDetail || null;
    if (includeQRCode && !billBank) {
      toast.error("This bill has no bank details for QR code");
      return;
    }
    _onPreview(
      selectedItem,
      sendWa,
      includeQRCode,
      billBank,
      selectedBillTemplate
    );
    setShowInvoiceSelectionDialog(false);
  };

  const handlePrintForCustomer = () => {
    if (!selectedItem) return;

    const billBank = selectedItem.bankDetail || null;
    if (includeQRCode && !billBank) {
      toast.error("This bill has no bank details for QR code");
      return;
    }
    // Use same server PDF as preview so print matches the generated PDF (not browser-rendered HTML)
    _onPreview(selectedItem, false, includeQRCode, billBank, selectedBillTemplate);
    setShowInvoiceSelectionDialog(false);
  };

  const RenderGroupChallansRow = (props) => {
    let { row } = props;
    if (!row) {
      return null;
    }
    let { orderId, orderNo, challanId, orderDate, party, items } = row;
    return (
      <>
        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
          {groupedChallansColumns.map((column) => {
            let value = row[column.id];
            if (column.id === "party") {
              value = value ? value.accountName : "";
            }

            return (
              <TableCell
                key={column.id}
                align={column.align}
                onClick={async () => {
                  if (column.id === "party") {
                    try {
                      let res = await axios.get(GetAccountAPI(row._id), {
                        headers: {
                          Authorization: `Bearer ${authToken}`,
                        },
                      });
                      setOpenAccountViewDialog({
                        open: true,
                        item: res.data,
                      });
                    } catch (e) {
                      // console.log("err:", e);
                      // toast.error(("Something went wrong, Please Contact Admin") , {
                      //   position: "top-center",
                      //   autoClose: 1500,
                      //   hideProgressBar: false,
                      //   closeOnClick: true,
                      //   pauseOnHover: true,
                      //   draggable: true,
                      //   progress: undefined,
                      //   theme: "light",
                      //   }); 
                    }
                  }
                }}
              >
                {column.format && typeof value === "number"
                  ? column.format(value)
                  : value}
              </TableCell>
            );
          })}
        </TableRow>
      </>
    );
  };

  const BillAddDialog = () => {

    const [users, setUsers] = useState([]);
    const [challans, setChallas] = useState([]);
    const [selectedChallans, setSelectedChallans] = useState([]);
    // const [selectedChallanvalue, setSelectedChallanvalue] = useState(false)
    const [buttonType, setButtonType] = useState(true)
    const [party, setParty] = useState(null);
    const [banks, setBanks] = useState([]);
    const [entityDetails, setEntityDetails] = useState(null);

    const [bank, setBank] = useState(null);
    const [invCreationDate, setInvCreationDate] = useState(moment());
    const [externalDiscountInput, setExternalDiscountInput] = useState("");
    const [isGeneratingBill, setIsGeneratingBill] = useState(false);
    let userInfo = useSelector((state) => state.userReducer.userInfo);
    let authToken = useSelector((state) => state.userReducer.authToken);

    const billPreviewSummary = useMemo(() => {
      if (!party || selectedChallans.length === 0) return null;
      const discPct = parseExternalDiscountForPreview(externalDiscountInput);
      return buildBillPreviewFromChallans(
        selectedChallans,
        !!party.isEligibleForIgst,
        discPct
      );
    }, [party, selectedChallans, externalDiscountInput]);

    useEffect(() => {
      _getUsers();
      _getBanks();
      _getEntityDetails();
    }, []);

    useEffect(() => {
      _getChallans();
    }, [party]);

    async function _getUsers() {
      try {
        let res = await axios.get(GetAllAccountsWithLightweightAPI(userInfo.entity, 'sale'), {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        let accounts = (res.data.accounts || []).filter(account => account.partyType === 'sale');

        console.log('Loaded sale parties:', accounts.length);
        setUsers(accounts);
      } catch (e) {
        console.error('Error loading parties:', e);
        toast.error('Failed to load parties. Please refresh.', {
          position: "top-center",
          autoClose: 2000,
        });
        setUsers([]);
      }
    }

    async function _getBanks() {
      try {
        let res = await axios.get(GetAllBanksAPI(userInfo.entity), {
          headers: {

            Authorization: `Bearer ${authToken}`,
          },
        });
        const nextBanks = res.data.banks || [];
        setBanks(nextBanks);
        // Keep selected bank "linked" to options after refresh to avoid MUI invalid value warning.
        setBank((prev) => {
          if (!prev) return prev;
          const match = nextBanks.find((b) => String(b?._id) === String(prev?._id));
          return match || null;
        });
      } catch (e) {
        console.error('Error loading banks:', e);
        setBanks([]);
        setBank(null);
      }
    }

    async function _getEntityDetails() {
      try {
        let res = await axios.get(GetEntityAPI(userInfo.entity), {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        console.log('Entity details loaded:', res.data);
        setEntityDetails(res.data);
      } catch (e) {
        console.error('Error loading entity details:', e);
        setEntityDetails(null);
      }
    }

    async function _getChallans() {
      if (!party) {
        return setChallas([]);
      }

      try {
        let query = `&userId=${party._id}&isBilled=${false}&isPaid=${false}`;
        let res = await axios.get(GetAllChallansAPI(userInfo.entity) + query, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        setChallas(res.data.challans);
      } catch (e) {
        // console.log("er:", e);
        // toast.error(('Cannot fetch data'), {
        //   position: "top-center",
        //   autoClose: 1500,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: "light",
        // });
      }
    }

    async function _onGenerate() {
      if (isGeneratingBill) return;
      try {
        if (!bank) {
          toast.error("Please select a bank", {
            position: "top-center",
            autoClose: 2000,
          });
          return;
        }

        if (!entityDetails) {
          toast.error("Entity details not loaded. Please wait or refresh.", {
            position: "top-center",
            autoClose: 2000,
          });
          return;
        }

        if (!party) {
          toast.error("Please select a party", {
            position: "top-center",
            autoClose: 2000,
          });
          return;
        }

        if (selectedChallans.length === 0) {
          toast.error("Please select at least one challan", {
            position: "top-center",
            autoClose: 2000,
          });
          return;
        }

        const discParsed = parseExternalDiscountForSubmit(externalDiscountInput);
        if (!discParsed.ok) {
          toast.error("Discount must be between 1 and 100, or leave blank for no discount.", {
            position: "top-center",
            autoClose: 2500,
          });
          return;
        }

        const preview = buildBillPreviewFromChallans(
          selectedChallans,
          !!party.isEligibleForIgst,
          discParsed.value
        );
        const merged = preview.merged;
        const finalBillAmount = preview.billAmount;

        console.log(party, "party while generating")

        const lock = Number(party?.balanceLock || 0);
        if (lock > 0) {
          const current = Number(party?.runningBillBalance ?? party?.runningChallanBalance ?? 0);
          const projected = current + Number(finalBillAmount || 0);
          if (projected > lock) {
            toast.error(
              `Balance locked for ${party?.name || "this account"}. Limit: ${lock}, Projected: ${Math.round(projected)}`,
              { position: "top-center", autoClose: 3000, theme: "light" }
            );
            return;
          }
        }

        setIsGeneratingBill(true);

        for (const i of selectedChallans) {
          await axios.patch(
            UpdateChallanBilledStatusAPI(i._id),
            { isBilled: true },
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
        }

        const challanIds = selectedChallans.map((c) => c._id);
        const challanCodes = selectedChallans.map((c) => c.code);

        let bill = {
          includeQRCode,
          entity: userInfo.entity,
          challanIds,
          amount: finalBillAmount,
          challanCodes,
          packagingCosts: merged.packagingCosts,
          packagingTaxPercents: merged.packagingTaxPercents,
          items: merged.items,
          externalDiscountPercentage: discParsed.value,
          bankDetail: bank,
          party: {
            accountId: party._id,
            accountCode: party.accountCode,
            accountName: party.name,
            accountAddress: party.address,
            accountGst: party.gstNumber,
            isEligibleForIgst: party.isEligibleForIgst
          },
          createdAt: Date.now(),
          entityDetails: entityDetails,
          invCreationDate: invCreationDate ? moment(invCreationDate).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY"),
        };
        console.log(bill, "My billllll")
        console.log('Entity details being sent:', entityDetails)

        // return
        let res = await axios.post(CreateBillAPI(), bill, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        setOpenBillAddDialog(false);
        toast.success("Bill Generated Successfully", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        _getBills(page, rowsPerPage, searchTerm);
      } catch (e) {
        console.error("Error creating bill:", e);
        console.error("Error response:", e.response?.data);

        const errorMessage = e.response?.data?.error || e.response?.data?.message || "Something went wrong, Please Contact Admin";

        toast.error(errorMessage, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } finally {
        setIsGeneratingBill(false);
      }
    }

    return (
      <Dialog
        TransitionComponent={Transition}
        maxWidth={"md"}
        fullWidth
        open={openBillAddDialog}
        onClose={() => setOpenBillAddDialog(false)}
      >
        <DialogContent>
          <GridContainer spacing={4}>
            <GridItem xs={12} sm={12} md={12}>
              <Autocomplete
                className={classes.formControl}
                options={users}
                fullWidth
                value={party}
                onChange={(event, value) => setParty(value)}
                getOptionLabel={(option) => option.name || option.accountName || ''}
                getOptionSelected={(option, value) => option._id === value._id}
                id="party"
                renderInput={(params) => (
                  <TextField {...params} label="Party" placeholder="Select Party" />
                )}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <Autocomplete
                multiple
                className={classes.formControl}
                options={challans}
                fullWidth
                value={selectedChallans}
                onChange={(event, value) => setSelectedChallans(value)}
                getOptionLabel={(option) => option.code}
                id="orders"
                renderInput={(params) => (
                  <TextField {...params} label="Challans" />
                )}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <Autocomplete
                className={classes.formControl}
                options={banks}
                fullWidth
                value={bank}
                onChange={(event, value) => setBank(value)}
                getOptionLabel={(option) => option.bankName}
                getOptionSelected={(option, value) => option?._id === value?._id}
                id="banks"
                renderInput={(params) => (
                  <TextField {...params} label="Banks" />
                )}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <MuiPickersUtilsProvider utils={DateUtils}>
                <DatePicker
                  label="Invoice Creation Date"
                  fullWidth
                  value={invCreationDate}
                  onChange={(date) => setInvCreationDate(date)}
                  format="DD-MM-YYYY"
                  animateYearScrolling
                />
              </MuiPickersUtilsProvider>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <TextField
                fullWidth
                label="Discount % (optional)"
                type="number"
                value={externalDiscountInput}
                onChange={(e) => setExternalDiscountInput(e.target.value)}
                inputProps={{ min: 1, max: 100, step: "any" }}
                helperText="1–100 for discount on taxable (pre-GST) amount; leave empty for none"
              />
            </GridItem>
            {billPreviewSummary && (
              <GridItem xs={12} sm={12} md={12}>
                <Box
                  className="border"
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 4,
                    padding: 12,
                    marginTop: 8,
                  }}
                >
                  <Typography variant="subtitle2" gutterBottom>
                    Selected challans summary
                  </Typography>
                  <Typography variant="body2">
                    Total challan (taxable): ₹
                    {Number(billPreviewSummary.taxableValue).toFixed(2)}
                  </Typography>
                  <Typography variant="body2">
                    Total item qty: {billPreviewSummary.totalQty}
                  </Typography>
                  {billPreviewSummary.discountPercent > 0 && (
                    <>
                      <Typography variant="body2">
                        Discount @ {billPreviewSummary.discountPercent}%: ₹
                        {Number(billPreviewSummary.discountAmount).toFixed(2)}
                      </Typography>
                      <Typography variant="body2">
                        Sub total: ₹
                        {Number(billPreviewSummary.discountedTaxable).toFixed(2)}
                      </Typography>
                    </>
                  )}
                  <Typography variant="body2">
                    Total GST: ₹{Number(billPreviewSummary.totalGst).toFixed(2)}
                  </Typography>
                  <Typography variant="body2" style={{ fontWeight: 600 }}>
                    Bill amount (payable): ₹
                    {Number(billPreviewSummary.billAmount).toFixed(2)}
                  </Typography>
                </Box>
              </GridItem>
            )}
            {/* <GridItem>
              <FormControlLabel
                          control={
                            <Checkbox
                              checked={includeQRCode}
                              onChange={(e) => setIncludeQRCode(e.target.checked)}
                              color="primary"
                            />
                          }
                          label="Include QR Code"
                        />
            </GridItem> */}
          </GridContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => _onGenerate()} color="primary" disabled={!(selectedChallans.length > 0 && bank !== null) || isGeneratingBill}>
            {isGeneratingBill ? "Generating…" : "Generate"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const BillEditDialog = () => {
    const [challans, setChallans] = useState([]);
    const [selectedChallans, setSelectedChallans] = useState([]);
    const [invCreationDate, setInvCreationDate] = useState(moment());
    const [submitting, setSubmitting] = useState(false);
    const authToken = useSelector((state) => state.userReducer.authToken);
    const userInfo = useSelector((state) => state.userReducer.userInfo);

    const parseInvDate = (value) => {
      if (!value) return moment();
      const parsed = moment(value, ["DD-MM-YYYY", moment.ISO_8601], true);
      return parsed.isValid() ? parsed : moment(value);
    };

    useEffect(() => {
      if (!openBillEditDialog || !billToEdit) return;
      setInvCreationDate(parseInvDate(billToEdit.invCreationDate || billToEdit.createdAt));
    }, [openBillEditDialog, billToEdit]);

    useEffect(() => {
      if (!openBillEditDialog || !billToEdit?.party?.accountId) return;
      _getEligibleChallans();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openBillEditDialog, billToEdit?._id, billToEdit?.party?.accountId]);

    async function _getEligibleChallans() {
      try {
        const query = `&userId=${billToEdit.party.accountId}&isPaid=false`;
        const res = await axios.get(GetAllChallansAPI(userInfo.entity) + query, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        const allPartyChallans = res.data.challans || [];
        const currentBillId = String(billToEdit._id);

        const eligible = allPartyChallans.filter((challan) => {
          const challanBillId = challan?.billId?._id || challan?.billId || null;
          const billedInCurrentBill = challanBillId && String(challanBillId) === currentBillId;
          return !challan.isBilled || billedInCurrentBill;
        });

        setChallans(eligible);

        const currentIds = new Set((billToEdit.challanIds || []).map((id) => String(id)));
        const preselected = eligible.filter((c) => currentIds.has(String(c._id)));
        setSelectedChallans(preselected);
      } catch (e) {
        console.error("Error loading challans for bill edit:", e);
        toast.error("Failed to load challans for editing", {
          position: "top-center",
          autoClose: 2000,
        });
        setChallans([]);
        setSelectedChallans([]);
      }
    }

    async function _onUpdateBill() {
      if (!billToEdit?._id) {
        toast.error("Invalid bill selected", { position: "top-center", autoClose: 1500 });
        return;
      }

      if (selectedChallans.length === 0) {
        toast.error("Please select at least one challan", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      setSubmitting(true);
      try {
        const merged = mergeChallansForBill(selectedChallans);

        const payload = {
          challanIds: selectedChallans.map((c) => c._id),
          challanCodes: selectedChallans.map((c) => c.code),
          amount: merged.totalChallanAmount,
          items: merged.items,
          packagingCosts: merged.packagingCosts,
          packagingTaxPercents: merged.packagingTaxPercents,
          invCreationDate: invCreationDate
            ? moment(invCreationDate).format("DD-MM-YYYY")
            : moment().format("DD-MM-YYYY"),
          externalDiscountPercentage:
            billToEdit.externalDiscountPercentage ?? 0,
        };

        await axios.patch(UpdateBillAPI(billToEdit._id), payload, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        toast.success("Bill updated successfully", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        handleCloseEditDialog();
        _getBills(page, rowsPerPage, searchTerm);
      } catch (e) {
        console.error("Error updating bill:", e);
        const errorMessage =
          e.response?.data?.error ||
          e.response?.data?.message ||
          "Failed to update bill. Please try again.";

        toast.error(errorMessage, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } finally {
        setSubmitting(false);
      }
    }

    return (
      <Dialog
        TransitionComponent={Transition}
        maxWidth={"md"}
        fullWidth
        open={openBillEditDialog}
        onClose={handleCloseEditDialog}
      >
        <DialogTitle>Edit Bill</DialogTitle>
        <DialogContent>
          <GridContainer spacing={4}>
            <GridItem xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                label="Party"
                value={billToEdit?.party?.accountName || ""}
                disabled
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <Autocomplete
                multiple
                className={classes.formControl}
                options={challans}
                fullWidth
                value={selectedChallans}
                onChange={(event, value) => setSelectedChallans(value)}
                getOptionLabel={(option) => option.code}
                getOptionSelected={(option, value) => option._id === value._id}
                id="edit-bill-challans"
                renderInput={(params) => (
                  <TextField {...params} label="Challans" />
                )}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <MuiPickersUtilsProvider utils={DateUtils}>
                <DatePicker
                  label="Invoice Creation Date"
                  fullWidth
                  value={invCreationDate}
                  onChange={(date) => setInvCreationDate(date)}
                  format="DD-MM-YYYY"
                  animateYearScrolling
                />
              </MuiPickersUtilsProvider>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={_onUpdateBill}
            color="primary"
            disabled={submitting || selectedChallans.length === 0}
          >
            {submitting ? "Updating..." : "Update"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const BulkBillDialog = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [party, setParty] = useState([]);
    const [users, setUsers] = useState([]);
    const [banks, setBanks] = useState([]);
    const [bank, setBank] = useState(null);
    const [groupedChallans, setGroupedChallans] = useState([]);
    const [partyChallans, setPartyChallans] = useState([]); // Store challans for selected parties
    const [loadingChallans, setLoadingChallans] = useState(false);
    const [invCreationDate, setInvCreationDate] = useState(moment());
    const [entityDetails, setEntityDetails] = useState(null);
    const [externalDiscountInput, setExternalDiscountInput] = useState("");
    let userInfo = useSelector((state) => state.userReducer.userInfo);
    let authToken = useSelector((state) => state.userReducer.authToken);

    const bulkPreviewSummary = useMemo(() => {
      if (!groupedChallans || groupedChallans.length === 0) return null;
      const challanObj = {};
      groupedChallans.forEach((item) => {
        const id = item.party.accountId;
        if (challanObj[id]) challanObj[id].push(item);
        else challanObj[id] = [item];
      });
      let sumTaxableValue = 0;
      let sumDiscountedTaxable = 0;
      let sumTotalGst = 0;
      let totalQty = 0;
      let billAmountSum = 0;
      let totalDiscountAmount = 0;
      const discPct = parseExternalDiscountForPreview(externalDiscountInput);
      Object.keys(challanObj).forEach((accountId) => {
        const companyChallans = challanObj[accountId];
        const p = users.find((u) => u._id === accountId);
        if (!p) return;
        const preview = buildBillPreviewFromChallans(
          companyChallans,
          !!p.isEligibleForIgst,
          discPct
        );
        sumTaxableValue += preview.taxableValue;
        sumDiscountedTaxable += preview.discountedTaxable;
        sumTotalGst += preview.totalGst;
        totalQty += preview.totalQty;
        billAmountSum += preview.billAmount;
        totalDiscountAmount += preview.discountAmount;
      });
      return {
        totalTaxableValue: sumTaxableValue,
        sumDiscountedTaxable,
        totalGst: sumTotalGst,
        totalQty,
        billAmount: billAmountSum,
        discountPercent: discPct,
        discountAmount: totalDiscountAmount,
      };
    }, [groupedChallans, users, externalDiscountInput]);

    // Step 1: Fetch parties when dialog opens
    useEffect(() => {
      _getUsers();
      _getEntityDetails();
    }, []);

    // Step 2: Fetch challans when party is selected
    useEffect(() => {
      if (party && party.length > 0) {
        _getPartyChallans();
      } else {
        setPartyChallans([]);
      }
    }, [party]);

    // Step 3: Fetch banks after challans are loaded
    useEffect(() => {
      if (partyChallans.length > 0 || (party && party.length > 0)) {
        _getBanks();
      }
    }, [partyChallans]);

    async function _getUsers() {
      try {
        let res = await axios.get(GetAllAccountsWithLightweightAPI(userInfo.entity), {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        let accounts = (res.data.accounts || []);
        console.log('Loaded sale parties:', accounts.length);
        setUsers(accounts);
      } catch (e) {
        console.error("Error fetching parties:", e);
        setUsers([]);
      }
    }

    async function _getPartyChallans() {
      if (!party || party.length === 0) {
        setPartyChallans([]);
        return [];
      }

      setLoadingChallans(true);
      try {
        // Get challans for all selected parties
        const partyIds = party.map((p) => p._id);
        const requests = partyIds.map((partyId) => {
          // Keep status=Active to avoid missing challans if API defaults change.
          const query = `&userId=${partyId}&status=Active&isBilled=false&isPaid=false`;
          return axios.get(GetAllChallansAPI(userInfo.entity) + query, {
            headers: { Authorization: `Bearer ${authToken}` },
          });
        });

        const responses = await Promise.all(requests);
        const allChallans = responses.flatMap((res) => res?.data?.challans || []);

        setPartyChallans(allChallans);
        return allChallans;
      } catch (e) {
        console.error("Error fetching party challans:", e);
        setPartyChallans([]);
        return [];
      } finally {
        setLoadingChallans(false);
      }
    }

    async function _getBanks() {
      try {
        let res = await axios.get(GetAllBanksAPI(userInfo.entity), {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        setBanks(res.data.banks || []);
      } catch (e) {
        console.error("Error fetching banks:", e);
        setBanks([]);
      }
    }

    async function _getEntityDetails() {
      try {
        let res = await axios.get(GetEntityAPI(userInfo.entity), {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        console.log('Bulk Bill - Entity details loaded:', res.data);
        setEntityDetails(res.data);
      } catch (e) {
        console.error('Bulk Bill - Error loading entity details:', e);
        setEntityDetails(null);
      }
    }

    async function _groupChallans() {
      if (!startDate || !endDate) {
        toast.error("Please select start and end dates");
        return;
      }

      if (!party || party.length === 0) {
        toast.error("Please select at least one party");
        return;
      }

      // Ensure challans are loaded (user can click quickly after selecting parties).
      let challansToUse = partyChallans;
      if ((!challansToUse || challansToUse.length === 0) && !loadingChallans) {
        challansToUse = await _getPartyChallans();
      }

      const partyIdSet = new Set((party || []).map((item) => String(item?._id || "")));

      // console.log([...partyIdSet], "party_id");
      // console.log(challansToUse, "partyChallans");

      // Use partyChallans (fetched for selected parties) instead of parent's challans
      // Only include challans whose challanDate (or createdAt fallback) lies within the selected start/end date range.
      let selected_challans = _.filter(challansToUse, (item) => {
        // challanDate is stored in DB as ISODate("2025-04-01T06:15:24.010+0000")
        // Fallback to createdAt if challanDate is missing.
        const challanMoment = item.challanDate
          ? moment(item.challanDate)
          : item.createdAt
            ? moment(item.createdAt)
            : null;

        if (!challanMoment || !challanMoment.isValid()) {
          return false;
        }

        // startDate / endDate come from MUI DatePicker (moment objects via @date-io/moment)
        const startDt = moment(startDate).startOf("day");
        const endDt = moment(endDate).endOf("day");

        // Inclusive range check: challanDate between startDt and endDt (both included)
        const isInRange = challanMoment.isBetween(startDt, endDt, undefined, "[]");

        if (
          isInRange &&
          partyIdSet.has(String(item?.party?.accountId || "")) &&
          item.paymentStatus === "Pending" &&
          item.isBilled === false
        ) {
          return true;
        }
        return false;
      });

      // console.log(selected_challans, "selected_challans");
      setGroupedChallans(selected_challans);
    }

    async function _createBill() {
      if (!entityDetails) {
        toast.error("Entity details not loaded. Please wait or refresh.", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      if (!bank) {
        toast.error("Please select a bank", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      if (groupedChallans.length === 0) {
        toast.error("No challans to bill", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      const discParsed = parseExternalDiscountForSubmit(externalDiscountInput);
      if (!discParsed.ok) {
        toast.error("Discount must be between 1 and 100, or leave blank for no discount.", {
          position: "top-center",
          autoClose: 2500,
        });
        return;
      }

      const challanObj = {};
      groupedChallans.forEach((item) => {
        const id = item.party.accountId;
        if (challanObj[id]) challanObj[id].push(item);
        else challanObj[id] = [item];
      });

      for (const accountId of Object.keys(challanObj)) {
        const party = _.filter(users, { _id: accountId })[0];
        if (!party) continue;
        const companyChallans = challanObj[accountId];
        const preview = buildBillPreviewFromChallans(
          companyChallans,
          !!party.isEligibleForIgst,
          discParsed.value
        );
        const merged = preview.merged;
        const finalAmount = preview.billAmount;

        const bill = {
          entity: userInfo.entity,
          challanIds: companyChallans.map((c) => c._id),
          challanCodes: companyChallans.map((c) => c.code),
          items: merged.items,
          amount: finalAmount,
          packagingCosts: merged.packagingCosts,
          packagingTaxPercents: merged.packagingTaxPercents,
          externalDiscountPercentage: discParsed.value,
          bankDetail: bank,
          party: {
            accountId: party._id,
            accountCode: party.accountCode,
            accountName: party.name,
            accountAddress: party.address,
            accountGst: party.gst,
            isEligibleForIgst: party.isEligibleForIgst,
          },
          createdAt: Date.now(),
          entityDetails: entityDetails,
          invCreationDate: invCreationDate
            ? moment(invCreationDate).format("DD-MM-YYYY")
            : moment().format("DD-MM-YYYY"),
        };
        try {
          await axios.post(CreateBillAPI(), bill, {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          });
        } catch (e) {
          console.error("Bulk create bill error:", e);
        }
      }

      for (const item of groupedChallans) {
        item.isBilled = true;
        try {
          await axios.patch(UpdateChallanAPI(item._id), item, {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          });
        } catch (e) {
          console.error("Bulk update challan error:", e);
        }
      }
      setOpenBulkBillDialog(false);
    }

    return (
      <Dialog
        onClose={(e, reason) => {
          // Only close if not clicking backdrop (or allow it based on your needs)
          setOpenBulkBillDialog(false);
        }}
        aria-labelledby="simple-dialog-title"
        open={openBulkBillDialog}
        fullScreen
      >
        <DialogContent>
          <CardHeader color="primary" style={{ marginTop: 16 }}>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <h4 className={classes.cardTitleWhite}>Create Bulk Bill</h4>
              <Button
                className={classes.cardTitleWhite}
                color={"white"}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setOpenBulkBillDialog(false);
                }}
              >
                Close
              </Button>
            </Box>
          </CardHeader>
          <GridContainer>
            <MuiPickersUtilsProvider utils={DateUtils}>
              <GridItem xs={12} sm={12} md={4} style={{ marginTop: 20 }}>
                <DatePicker
                  label="Start Date"
                  fullWidth
                  value={startDate}
                  onChange={(date) => setStartDate(date)}
                  animateYearScrolling
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4} style={{ marginTop: 20 }}>
                <DatePicker
                  label="End Date"
                  fullWidth
                  value={endDate}
                  onChange={(date) => setEndDate(date)}
                  animateYearScrolling
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4} >
                <Autocomplete
                  multiple
                  className={classes.formControl}
                  // options={_.filter(users, { cashPreference: true })}
                  options={_.filter(users, { cashPreference: false })}
                  fullWidth
                  value={party}
                  onChange={(event, value) => setParty(value)}
                  getOptionLabel={(option) => option.name}
                  id="party"
                  renderInput={(params) => (
                    <TextField {...params} label="Party*" />
                  )}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4} style={{ marginTop: 20 }}>
                <DatePicker
                  label="Invoice Creation Date"
                  fullWidth
                  value={invCreationDate}
                  onChange={(date) => setInvCreationDate(date)}
                  format="DD-MM-YYYY"
                  animateYearScrolling
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6} >
                <Autocomplete
                  className={classes.formControl}
                  options={banks}
                  fullWidth
                  value={bank}
                  onChange={(event, value) => setBank(value)}
                  disabled={!party || party.length === 0 || loadingChallans}
                  getOptionLabel={(option) => option.bankName}
                  getOptionSelected={(option, value) => option?._id === value?._id}
                  id="banks"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Banks*"
                      helperText={!party || party.length === 0 ? "Select parties first" : ""}
                    />
                  )}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4} style={{ marginTop: 20 }}>
                <TextField
                  fullWidth
                  label="Discount % (optional)"
                  type="number"
                  value={externalDiscountInput}
                  onChange={(e) => setExternalDiscountInput(e.target.value)}
                  inputProps={{ min: 1, max: 100, step: "any" }}
                  helperText="Applied per bill; 1–100 or empty"
                />
              </GridItem>

              <GridItem
                xs={12}
                sm={12}
                md={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  onClick={_groupChallans}
                  disabled={!party || party.length === 0 || !startDate || !endDate || loadingChallans}
                >
                  {loadingChallans ? "Loading Challans..." : "Generate Grouped Challans"}
                </Button>
              </GridItem>
            </MuiPickersUtilsProvider>
          </GridContainer>
          {!_.isEmpty(groupedChallans) && bulkPreviewSummary && (
            <Box
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: 4,
                padding: 12,
                margin: "12px 16px",
              }}
            >
              <Typography variant="subtitle2" gutterBottom>
                Grouped challans summary (all parties)
              </Typography>
              <Typography variant="body2">
                Total challan (taxable): ₹
                {Number(bulkPreviewSummary.totalTaxableValue).toFixed(2)}
              </Typography>
              <Typography variant="body2">
                Total item qty: {bulkPreviewSummary.totalQty}
              </Typography>
              {bulkPreviewSummary.discountPercent > 0 && (
                <>
                  <Typography variant="body2">
                    Total discount @ {bulkPreviewSummary.discountPercent}%: ₹
                    {Number(bulkPreviewSummary.discountAmount).toFixed(2)}
                  </Typography>
                  <Typography variant="body2">
                    Sub total: ₹
                    {Number(bulkPreviewSummary.sumDiscountedTaxable).toFixed(2)}
                  </Typography>
                </>
              )}
              <Typography variant="body2">
                Total GST: ₹{Number(bulkPreviewSummary.totalGst).toFixed(2)}
              </Typography>
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                Bill amounts total (payable): ₹
                {Number(bulkPreviewSummary.billAmount).toFixed(2)}
              </Typography>
            </Box>
          )}
          {!_.isEmpty(groupedChallans) && (
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {groupedChallansColumns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {groupedChallans.map((row) => {
                  return <RenderGroupChallansRow {...props} row={row} />;
                })}
              </TableBody>
            </Table>
          )}
        </DialogContent>
        <DialogActions>
          {!_.isEmpty(groupedChallans) && (
            <Button
              variant="contained"
              type="button"
              color="primary"
              onClick={_createBill}
            >
              Generate Bills
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  };


  let data = bills;

  if (filter) {
    let { startDate, endDate, party, status } = filter;
    if (startDate && endDate) {
      const start = moment(startDate).startOf("day");
      const end = moment(endDate).endOf("day");
      data = _.filter(data, (i) => {
        const invDate = moment(i.invCreationDate, "DD-MM-YYYY", true);
        if (!invDate.isValid()) return true;
        return invDate.isBetween(start, end, "day", "[]");
      });
    }
    if (party) {
      data = _.filter(data, (i) => {
        return i.party.accountName === party;
      });
    }
    if (status) {
      data = _.filter(data, (i) => {
        return i.paymentStatus === status;
      });
    }
  }

  // Export bills data to Excel with required columns
  const handleExport = async () => {
    if (!data || data.length === 0) {
      toast.error("No bills to export!", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    setIsExporting(true);
    try {
      const worksheetData = await Promise.all(
        data.map(async (bill) => {
          const items = bill.items || [];
          const billAddress = bill.party?.accountAddress || "";

          // Mirror the invoice template calculations so exported totals match the PDF.
          // IMPORTANT: eligibility is stored on the Account (ledger), so use it from account API.
          let isEligibleForIgst = false;
          let partyGstNumber = "";

          try {
            if (bill.party?.accountId) {
              const res = await axios.get(GetAccountAPI(bill.party.accountId), {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
              });
              partyGstNumber = res.data.gstNumber || "";
              isEligibleForIgst = !!res.data.isEligibleForIgst;
            }
          } catch (err) {
            console.error("Failed to fetch account for export:", err);
          }

          const pkgTaxAmt = (bill.packagingCosts || []).reduce((sum, cost, i) => sum + (Number(cost) * Number(bill.packagingTaxPercents?.[i] || 0)) / 100, 0);
          const inv = computeInvoiceTotals(
            items,
            (bill.packagingCosts || []).reduce((a, b) => a + Number(b), 0),
            isEligibleForIgst,
            pkgTaxAmt
          );
          const disc = applyExternalDiscountOnTaxable(
            inv,
            Number(bill.externalDiscountPercentage) || 0,
            isEligibleForIgst
          );

          const billNumberOnly = getBillNumber(bill);

          // Bill date for export: invoice creation date only (stored as DD-MM-YYYY).
          const billDateFormatted = parseBillDateForDisplay(bill.invCreationDate);

          return {
            "Bill Number": billNumberOnly,
            "Bill Date": billDateFormatted,
            "Bill Address": billAddress,
            "Name": bill.party?.accountName || "",
            "GST Number": partyGstNumber || "",
            "Total Qty": inv.totalQuantity,
            "Discount Amount": _.round(disc.discountAmount, 2).toFixed(2),
            "Without GST Amount": _.round(disc.discountedTaxable, 2).toFixed(2),
            "IGST Amount": _.round(
              isEligibleForIgst ? disc.totalIgstAfter : 0,
              2
            ).toFixed(2),
            "CGST Amount": _.round(
              isEligibleForIgst ? 0 : disc.totalCgstAfter,
              2
            ).toFixed(2),
            "SGST Amount": _.round(
              isEligibleForIgst ? 0 : disc.totalSgstAfter,
              2
            ).toFixed(2),
            "Total Bill Amount": _.round(disc.finalGrandTotal, 2).toFixed(2),
          };
        })
      );

      const toSafeNumber = (value) => {
        const n = Number(value);
        return Number.isFinite(n) ? n : 0;
      };

      const totals = worksheetData.reduce(
        (acc, row) => {
          acc.totalQty += toSafeNumber(row["Total Qty"]);
          acc.discountAmount += toSafeNumber(row["Discount Amount"]);
          acc.withoutGstAmount += toSafeNumber(row["Without GST Amount"]);
          acc.igstAmount += toSafeNumber(row["IGST Amount"]);
          acc.cgstAmount += toSafeNumber(row["CGST Amount"]);
          acc.sgstAmount += toSafeNumber(row["SGST Amount"]);
          acc.totalBillAmount += toSafeNumber(row["Total Bill Amount"]);
          return acc;
        },
        {
          totalQty: 0,
          discountAmount: 0,
          withoutGstAmount: 0,
          igstAmount: 0,
          cgstAmount: 0,
          sgstAmount: 0,
          totalBillAmount: 0,
        }
      );

      const worksheetWithTotals = [
        ...worksheetData,
        {
          "Bill Number": "TOTAL",
          "Bill Date": "",
          "Bill Address": "",
          "Name": "",
          "GST Number": "",
          "Total Qty": totals.totalQty,
          "Discount Amount": _.round(totals.discountAmount, 2).toFixed(2),
          "Without GST Amount": _.round(totals.withoutGstAmount, 2).toFixed(2),
          "IGST Amount": _.round(totals.igstAmount, 2).toFixed(2),
          "CGST Amount": _.round(totals.cgstAmount, 2).toFixed(2),
          "SGST Amount": _.round(totals.sgstAmount, 2).toFixed(2),
          "Total Bill Amount": _.round(totals.totalBillAmount, 2).toFixed(2),
        },
      ];

      const worksheet = XLSX.utils.json_to_sheet(worksheetWithTotals);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");
      XLSX.writeFile(workbook, "bills_export.xlsx");

      toast.success(`Successfully exported ${worksheetData.length} bills to Excel!`, {
        position: "top-center",
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Bill export error:", error);
      toast.error(
        error.response?.data?.message ||
        "Failed to export bills. Please try again.",
        {
          position: "top-center",
          autoClose: 3000,
        }
      );
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        sx={{ m: 2 }}
      >
        <Tooltip title="Export to Excel">
          <IconButton
            color="primary"
            onClick={handleExport}
            disabled={isExporting}
          >
            <CloudDownload />
          </IconButton>
        </Tooltip>
        <Button
          variant="contained"
          color="primary"
          disabled={openBulkBillDialog}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!openBulkBillDialog) {
              setOpenBulkBillDialog(true);
            }
          }}
        >
          Bulk Bills
        </Button>
        <IconButton aria-label="add" onClick={() => setOpenBillAddDialog(true)}>
          <AddIcon />
        </IconButton>
      </Box>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align}
                style={{ minWidth: column.minWidth }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={columns.length} align="center" style={{ padding: "40px" }}>
                <CircularProgress />
                <Box style={{ color: "#666", marginTop: "16px" }}>
                  {searchTerm ? "Searching bills..." : "Loading bills..."}
                </Box>
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columns.length} align="center" style={{ padding: "40px" }}>
                <Box style={{ color: "#666" }}>
                  {searchTerm ? "No bills found matching your search." : "No bills found."}
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            data.map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  {columns.map((column) => {
                    let value = row[column.id];

                    if (column.id === "billNumber") {
                      return (
                        <TableCell key={column.id}>
                          {getBillNumber(row)}
                        </TableCell>
                      );
                    }

                    if (column.id === "qty") {
                      return (
                        <TableCell key={column.id} align="right">
                          {getTotalBillQty(row.items)}
                        </TableCell>
                      );
                    }

                    if (column.id === "isPaid") {
                      return (
                        <TableCell key={column.id}>
                          {row.isPaid === true ? "Yes" : "No"}
                        </TableCell>
                      );
                    }

                    if (column.id === "createdAt") {
                      return (
                        <TableCell key={column.id}>
                          {moment(value).format("DD-MM-YYYY")}
                        </TableCell>
                      );
                    }

                    if (column.id === "invCreationDate") {
                      return (
                        <TableCell key={column.id}>
                          {parseBillDateForDisplay(value)}
                        </TableCell>
                      );
                    }

                    if (column.id === "party") {
                      value = value.accountName;
                    }
                    if (column.id === "action") {
                      return (
                        // <TableCell align={"center"}>
                        //   <Box display={"flex"} justifyContent={"center"}>
                        //     <IconButton
                        //       onClick={() => _onPreview(row)}
                        //       aria-label="view"
                        //     >
                        //       <Receipt />
                        //     </IconButton>
                        //     <IconButton
                        //       aria-label="view"
                        //       onClick={() =>
                        //         setOpenViewDialog({
                        //           open: true,
                        //           item: row,
                        //         })
                        //       }
                        //     >
                        //       <VisibilityIcon />
                        //     </IconButton>
                        //   </Box>
                        // </TableCell>
                        <TableCell key={column.id} align="center">
                          <Box display="flex" justifyContent="center">
                            <IconButton onClick={() => handlePrintDialog(row)} aria-label="preview">
                              <Receipt />
                            </IconButton>

                            <IconButton
                              aria-label="view"
                              onClick={() => {
                                const pcArray = [...(row.packagingCosts || [])];
                                pcArray.valueOf = function() { return this.reduce((a, b) => a + Number(b), 0); };
                                setOpenViewDialog({
                                  open: true,
                                  item: { ...row, packagingCosts: pcArray },
                                });
                              }}
                            >
                              <VisibilityIcon />
                            </IconButton>

                            <IconButton
                              aria-label="edit"
                              onClick={() => handleOpenEditDialog(row)}
                            >
                              <EditIcon />
                            </IconButton>

                            <IconButton
                              aria-label="delete"
                              onClick={() => {
                                setSelectedItem(row);
                                setDeleteDialogOpen(true);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                            <IconButton
                              aria-label="view"
                              onClick={() => handlePrintDialog(row, true)}
                            >
                              <WhatsAppIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === "number"
                          ? column.format(value)
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={billTotal}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {/*<Fab color="primary" aria-label="add" className={classes.fab}*/}
      {/*     onClick={() => setOpenBillAddDialog(true)}>*/}
      {/*    <AddIcon/>*/}
      {/*</Fab>*/}
      <BillAddDialog />
      <BillEditDialog />
      <BulkBillDialog />
      {openViewDialog ? (
        <BillView
          open={openViewDialog.open}
          close={closeViewDialog}
          item={openViewDialog.item}
        />
      ) : null}
      <BillPrintDialog
        open={showInvoiceSelectionDialog}
        onClose={() => setShowInvoiceSelectionDialog(false)}
        billTemplates={billTemplates}
        selectedBillTemplate={selectedBillTemplate}
        setSelectedBillTemplate={setSelectedBillTemplate}
        includeQRCode={includeQRCode}
        onToggleQRCode={handleQRCodeToggle}
        banks={banks}
        selectedBankId={selectedBankId}
        handlePrintForCustomer={handlePrintForCustomer}
      />
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this bill? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => handleConfirmDelete()}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}, (prevProps, nextProps) => {
  // Custom comparison function to prevent unnecessary re-renders
  return (
    prevProps.searchTerm === nextProps.searchTerm &&
    prevProps.filter === nextProps.filter &&
    prevProps.accounts === nextProps.accounts &&
    prevProps.readyMasterRange === nextProps.readyMasterRange
  );
});